import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import * as Analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE, ActionOrigin, COMMON_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import DatasetTabState from './DatasetTabState';
import DatasetView from './DatasetView';

export default class DatasetTabView extends Backbone.View<DatasetTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): this {
    const id = this.model.get('id');
    renderToDOM(<DatasetView id={id} />, this.el);
    Analytics.trackEventWithModule(
      COMMON_ANALYTICS_ACTIONS.VIEWED_WORKSPACE_ITEM,
      ANALYTICS_MODULE.INSIGHTS,
      {
        event_group_id: Analytics.makeAnalyticsEventId(),
        action_origin: ActionOrigin.UI_UNDETERMINED,
        viewed_object_id: id,
        viewed_object_type: 'dataset',
      }
    );
    return this;
  }

  override remove(): Backbone.View<DatasetTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

DatasetTabView.initClass();
